import { render } from "./AccordionPage.vue?vue&type=template&id=ba941ee4&scoped=true"
import script from "./AccordionPage.vue?vue&type=script&lang=js"
export * from "./AccordionPage.vue?vue&type=script&lang=js"

import "./AccordionPage.vue?vue&type=style&index=0&id=ba941ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba941ee4"]])

export default __exports__